import { StyleSheet } from 'react-native';
import theme from '../../common/theme';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 8,
    paddingVertical: 40,
    paddingHorizontal: 20,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.grey1,
  },
  icon: {
    transform: [{ scale: 0.8 }],
    marginBottom: 8,
  },
  text: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    color: theme.colors.grey6,
    fontFamily: theme.fonts.medium,
  },
});

export default styles;
